import { Building2 } from "lucide-react";
import { BRANCHES } from "@/lib/format";

export const BranchTabs = ({ value, onChange, events }) => {
  const opts = [["all", "Todas as filiais"], ...Object.entries(BRANCHES)];
  return (
    <section data-testid="branch-tabs" className="mb-6 flex gap-2 overflow-x-auto border-b border-slate-800 pb-px">
      {opts.map(([k, label]) => {
        const count = k === "all" ? events.length : events.filter((e) => e.branch === k).length;
        const active = value === k;
        return (
          <button key={k} data-testid={`branch-tab-${k}`} onClick={() => onChange(k)}
            className={`-mb-px flex shrink-0 items-center gap-2 border-b-2 px-4 py-3 font-display text-lg font-semibold uppercase tracking-wide transition-colors ${active ? "border-amber-500 text-white" : "border-transparent text-slate-400 hover:text-white"}`}>
            {k !== "all" && <Building2 size={15} className={active ? "text-amber-400" : ""} />}
            {label}
            <span className="rounded-sm bg-slate-800 px-1.5 font-mono text-[10px] text-slate-300">{count}</span>
          </button>
        );
      })}
    </section>
  );
};
